import { PublicLayout } from './PublicLayout'
import { Link } from 'react-router-dom'
import { Outlet, Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

export function AuthLayout() {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    )
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />
  }

  return (
    <PublicLayout><div className="flex items-center justify-center px-5 py-12">
      <div className="w-full max-w-md">
        <p className="text-sm text-muted-foreground text-center mb-6">После регистрации добавьте один актив, затем его поступления — и получите первую сводку.</p><Outlet /><Link to="/demo" className="block text-center mt-6 text-sm underline underline-offset-4">Сначала посмотреть пример без регистрации</Link>
      </div>
    </div></PublicLayout>
  )
}
